<script>
import Base from '@/plans/ADDITIONAL_HOST/success.vue';
export default {
  extends: Base,
  computed: {
    getUnassignTxt() {
      return this.$t('billing.success.downgrade_seat_licenses_co', [this.unassignLicenses, this.billingDate]);
    },
    getUnassignTxt2(){
      return this.$t('billing.success.downgrade_seat_co_process');
    },
  }
}
</script>
